import { apiFetch } from "./api";

export interface Display {
  type: string;
}

export interface Querie {
  id: string;
  name: string;
  params: [];
  display: Display[];
}

export interface Module {
  id: string;
  label: string;
  description: string;
  entrypoint: string;
  queries: Querie[]
}

export interface GenericModule {
  id: string,
  label: string
}

export function getModules() {
  return apiFetch<Module[]>(`/api/manifest/modules`);
}

export interface ModuleUser {
  user_id: string;
  user_name: string;
  user_email: string;
  company_id: string;
  company_name: string;
  client_id: string;
}

export function getUsersByModule(moduleId: string, clientId?: string) {
  const params = new URLSearchParams();
  if (clientId) params.set('client_id', clientId);
  const paramString = params.toString();
  return apiFetch<ModuleUser[]>(`/api/modules/${moduleId}/users${paramString ? "?" + paramString : ""}`);
}